import { connect } from 'react-redux';
import { setBookingStep, setCart, setDataByStep, setLoading } from '../../Actions';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { CheckCircle, EventNote, LocationPin, PaidOutlined, Person } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import PaymentForm from '../Organisms/PaymentForm';
import moment from 'moment';
import { get, map, round } from 'lodash';
import { Elements } from '@stripe/react-stripe-js';
import { book } from '../../Helpers';
import { loadStripe } from '@stripe/stripe-js';
import { EMAILREGEX } from '../../Assets/constants';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_TOKEN)

function Summary(props) {
    const { setDataByStep, setBookingStep, setAlert, setLoading } = props;
    const location_name = get(props, "1.location.name", "") ? get(props, "1.location.name", "") : get(props, "3.location_name", "");
    const room_number = get(props, "3.room_number", "") ? get(props, "3.room_number", "") : "";
    const location_id = get(props, "1.location.id", "") ? get(props, "1.location.id", "") : get(props, "3.location_id", "");
    const hasTotalAmount = Number(get(props, "3.total", 0)) > 0;
    const paymentRequired = props[2]?.payment_required && hasTotalAmount;
    const date = get(props, "3.date", "");
    const timesBySlot = get(props, "3.timesBySlot", []);
    const [userInfo, setUserInfo] = useState({
        first_name: "",
        last_name: "",
        provider_notes: "",
        email: "",
        validEmail: false,
    })
    const [paymentInfo, setPaymentInfo] = useState({
        card_number: "",
        card_expiry: "",
        card_cvc: "",
        card_zip: ""
    })
    const [readyToSubmit, setReadyToSubmit] = useState(false);

    useEffect(() => {
        const { first_name, last_name, email, validEmail } = userInfo;
        const { card_number, card_expiry, card_cvc, card_zip } = paymentInfo;
        if (paymentRequired) {
            setReadyToSubmit(Boolean(first_name && last_name && email && card_number && card_expiry && card_cvc && card_zip && validEmail))
        } else {
            setReadyToSubmit(Boolean(first_name && last_name && email && validEmail));
        }
    }, [userInfo, paymentInfo, paymentRequired]);

    const submitFormAndBook = (token = {}) => {
        const { card } = token;
        const { first_name, last_name, provider_notes, email, validEmail } = userInfo;
        if (!first_name || !last_name || !(email && validEmail) || (!token && paymentRequired)) {
            setAlert("error", "Please fill all required fields");
            return;
        }
        setLoading(true);
        const bookingData = {
            location_id,
            first_name,
            last_name,
            provider_notes,
            slot_ids: get(props, "3.slotIds", []),
            email,
            ...!paymentRequired ? {} : {
                credit_card: {
                    // id: card.id,
                    last_4: card?.last4,
                    stripe_id: token.id,
                    name: card?.name || `${first_name} ${last_name}`,
                    exp_month: card?.exp_month,
                    exp_year: card?.exp_year,
                    type: card?.funding,
                    brand: card?.brand,
                    "default": true,
                    zip_code: paymentInfo.card_zip,
                }
            }
        }
        book(bookingData, (response) => {
            setLoading(false);
            let { success, result } = response.data;
            if (success || result) {
                setAlert("success", "Booking successful");
                setDataByStep(4, bookingData);
                setBookingStep(4);
            } else {
                setAlert("error", get(response, "data.message", "Booking failed"));
            }
        }, (err) => {
            setLoading(false);
            setAlert("error", get(err, 'response.data.message', "Booking failed"));
        })

    }

    const formView = () => {
        return (<>
            <form onSubmit={(e) => { e.preventDefault() }} className=' txt-align-left' noValidate>
                <div className="row">
                    <div className={`col-12 col-sm-6 `}>
                        <div className={`form-group mb-16`}>
                            <label htmlFor="firstName" className="mb-8 font-weight-bold size-16-20">First name*</label>
                            <input type="text" id="firstName" className="form-control generic-input-style" placeholder='Enter'
                                value={userInfo.first_name} onChange={(event) => setUserInfo({ ...userInfo, first_name: event.target.value })}
                                required
                            />
                        </div>
                    </div><div className={`col-12 col-sm-6 `}>
                        <div className={`form-group mb-16`}>
                            <label htmlFor="lastName" className="mb-8 font-weight-bold size-16-20">Last name*</label>
                            <input type="text" id="lastName" className="form-control generic-input-style" placeholder='Enter'
                                value={userInfo.last_name} onChange={(event) => setUserInfo({ ...userInfo, last_name: event.target.value })}
                                required
                            />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className={`form-group mb-16`}>
                            <label htmlFor="email" className="mb-8 font-weight-bold size-16-20">Email*</label>
                            <input type="email" id="email" className="form-control generic-input-style" aria-describedby="emailHelp" placeholder="Enter email"
                                value={userInfo.email} onChange={(event) => {
                                    setUserInfo({ ...userInfo, email: event.target.value, validEmail: EMAILREGEX.test(event.target.value) })
                                }}
                                required
                            />
                            {userInfo.validEmail || !userInfo.email ?
                                paymentRequired ? <small id="emailHelp" className="form-text size-14-20 contentTertiary" style={{
                                    display: "inline-flex", alignItems: "center"
                                }}>This is where we'll send your receipt.
                                    {userInfo.validEmail ? <CheckCircle className='systemGreen ml-6' fontSize='14px' /> : " Please enter a valid email address."}
                                </small> : null
                                : <small id="emailHelp" className={`form-text size-14-20 systemRed`}>
                                    Please enter a valid email address.
                                </small>}
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className="form-group mb-32 mb-sm-24 mt-16">
                            <label htmlFor="exampleFormControlTextarea1" className='font-weight-bold mb-8 size-16-20'>Note to Provider <span className='contentTertiary'>(Optional)</span></label>
                            <textarea className="form-control text-area-style" id="exampleFormControlTextarea1"
                                style={{
                                    backgroundColor: "#EEE",
                                }}
                                rows="5" maxLength='1200'
                                onChange={(event) => setUserInfo({ ...userInfo, provider_notes: event.target.value })}
                                value={userInfo.provider_notes}
                                placeholder="Enter any requests or notes to Providers here"
                            ></textarea>
                            {/* <span className="text-area-counter font-style-regular">{userInfo.provider_notes?.length || 0}/ 1200 characters</span> */}
                        </div>
                    </div>
                </div>

            </form>

            {paymentRequired ? <PaymentForm paymentRequired={paymentRequired} setPaymentInfo={setPaymentInfo} paymentInfo={paymentInfo}
                submitFormAndBook={submitFormAndBook} setAlert={setAlert} stripePromise={stripePromise} userInfo={userInfo}
                readyToSubmit={readyToSubmit}
            />
                : null}

            {paymentRequired ? null : <div className='fxd-btm'>
                <span className='mr-16 size-18-24 font-weight-bold'>By clicking "Book" above, you agree to our <a className='BluePrimary' href="https://www.soothe.com/terms-and-conditions/">Terms and Conditions</a> and <a className='BluePrimary'
                    href="https://www.soothe.com/privacy-policy/">Privacy Policy</a></span>
                <button
                    type="button"
                    className="btn cta-primary p-16-20-imp"
                    disabled={!readyToSubmit}
                    onClick={(e) => {
                        e?.preventDefault();
                        if (!readyToSubmit) return;
                        submitFormAndBook();
                    }}
                >
                    Book now
                </button>
            </div>}
        </>)
    }
    if (paymentRequired && !stripePromise) {
        return null;
    }
    return (<Elements stripe={stripePromise}>
        <div className='contentPrimary font-weight-bold size-44-52 sm-size-28-36 mb-16 sm-mb-8'>
            Summary
        </div>
        <div className=' txt-align-left'>
            <MenuList className='mb-24'>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <EventNote fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Date</span>}
                        secondary={moment(date, "YYYY-MM-DD").format("ddd, MMM D") + ", " + map(timesBySlot, item => `${item.start_time}-${item.end_time}`).join(', ')}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <LocationPin fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Location</span>}
                        secondary={location_name + " " + room_number}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <Person fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Provider</span>}
                        secondary={get(props, "3.provider_name", "") || "Provider TBD"}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <PaidOutlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Total</span>}
                        secondary={`$${round(get(props, "3.total", 0), 2).toFixed(2)}`}
                    />
                </MenuItem>
            </MenuList>
            <div className='contentPrimary font-weight-bold size-24-32 sm-size-28-36 mb-16 sm-mb-8 mt-16'>
                Your Information
            </div>
            <div className=''>
                {formView()}
            </div>
        </div>
    </Elements>);
}
const mapStateToProps = (state) => ({
    ...state.booking, loading: state.booking.loading,
});
export default connect(mapStateToProps, {
    setBookingStep, setDataByStep, setCart, setLoading
})(Summary);